import {
  GET_ADMIN_USERS,
  GET_ADMIN_USERS_SUCCESS,
  GET_ADMIN_USERS_ERROR,
  GET_OLD_ADMIN_USERS,
  GET_OLD_ADMIN_USERS_SUCCESS,
  GET_OLD_ADMIN_USERS_ERROR,
  UPDATE_CLIENTS,
  UPDATE_CLIENTS_SUCCESS,
  UPDATE_CLIENTS_ERROR,
  GET_CLIENT_USERS_BY_ACCOUNT_ID,
  GET_CLIENT_USERS_BY_ACCOUNT_ID_SUCCESS,
  GET_CLIENT_USERS_BY_ACCOUNT_ID_ERROR,
  RESET_LAST_COMPLETED_ACTION,
  CREATE_ADMIN_RECENT_VISIT_ERROR,
  CREATE_ADMIN_RECENT_VISIT_SUCCESS,
  CREATE_ADMIN_RECENT_VISIT,
  GET_ADMIN_RECENT_VISIT,
  GET_ADMIN_RECENT_VISIT_SUCCESS,
  GET_ADMIN_RECENT_VISIT_ERROR,
  GET_REGISTRATION_PENDING_USERS,
  GET_REGISTRATION_PENDING_USERS_SUCCESS,
  GET_REGISTRATION_PENDING_USERS_ERROR,
  SEND_ADMIN_CLIENT_INVITE_MAIL,
  SEND_ADMIN_CLIENT_INVITE_MAIL_SUCCESS,
  SEND_ADMIN_CLIENT_INVITE_MAIL_ERROR,
  DELETE_REGISTRATION_PENDING_USER,
  DELETE_REGISTRATION_PENDING_USER_SUCCESS,
  DELETE_REGISTRATION_PENDING_USER_ERROR
} from "./actionTypes"

export const getAdminUsers = (query_params, paginated, isV2AdminClientsAPIEnabled) => {
  return {
    type: GET_ADMIN_USERS,
    payload: query_params,
    paginated: paginated,
    isV2AdminClientsAPIEnabled: isV2AdminClientsAPIEnabled
  }
}

export const getAdminUsersSuccess = (admin_users, paginated) => {
  return {
    type: GET_ADMIN_USERS_SUCCESS,
    payload: admin_users,
    paginated: paginated
  }
}

export const getAdminUsersError = error => {
  return {
    type: GET_ADMIN_USERS_ERROR,
    payload: error,
  }
}

export const getRegistrationPendingUsers = (query_params) => {
  return {
    type: GET_REGISTRATION_PENDING_USERS,
    payload: query_params
  }
}

export const getRegistrationPendingUsersSuccess = (admin_users) => {
  return {
    type: GET_REGISTRATION_PENDING_USERS_SUCCESS,
    payload: admin_users
  }
}

export const getRegistrationPendingUsersError = error => {
  return {
    type: GET_REGISTRATION_PENDING_USERS_ERROR,
    payload: error,
  }
}

export const getOldAdminUsers = () => {
  return {
    type: GET_OLD_ADMIN_USERS
  }
}

export const getOldAdminUsersSuccess = (admin_users) => {
  return {
    type: GET_OLD_ADMIN_USERS_SUCCESS,
    payload: admin_users
  }
}

export const getOldAdminUsersError = error => {
  return {
    type: GET_OLD_ADMIN_USERS_ERROR,
    payload: error,
  }
}

export const getClientUsersByAccountId = user => {
  return {
    type: GET_CLIENT_USERS_BY_ACCOUNT_ID,
    payload: user
  }
}

export const getClientUsersByAccountIdSuccess = client_users => {
  return {
    type: GET_CLIENT_USERS_BY_ACCOUNT_ID_SUCCESS,
    payload: client_users,
  }
}

export const getClientUsersByAccountIdError = error => {
  return {
    type: GET_CLIENT_USERS_BY_ACCOUNT_ID_ERROR,
    payload: error,
  }
}

export const resetLastCompletedAction = () => ({
  type: RESET_LAST_COMPLETED_ACTION,
});

export const updateClient = client => {
  return {
    type: UPDATE_CLIENTS,
    payload: client
  }
}

export const updateClientSuccess = clients => {
  return {
    type: UPDATE_CLIENTS_SUCCESS,
    payload: clients
  }
}

export const updateClientError = error => {
  return {
    type: UPDATE_CLIENTS_ERROR,
    payload: error,
  }
}

export const deleteRegistrationPendingUser = (payload) => {
  return {
    type: DELETE_REGISTRATION_PENDING_USER,
    payload: payload,
  }
}

export const deleteRegistrationPendingUserSuccess = payload => {
  return {
    type: DELETE_REGISTRATION_PENDING_USER_SUCCESS,
    payload: payload,
  }
}

export const deleteRegistrationPendingUserError = error => {
  return {
    type: DELETE_REGISTRATION_PENDING_USER_ERROR,
    payload: error,
  }
}
export const createAdminRecentVisit = payload => {
  return {
    type: CREATE_ADMIN_RECENT_VISIT,
    payload: payload
  }
}

export const createAdminRecentVisitSuccess = payload => {
  return {
    type: CREATE_ADMIN_RECENT_VISIT_SUCCESS,
    payload: payload
  }
}

export const createAdminRecentVisitError = error => {
  return {
    type: CREATE_ADMIN_RECENT_VISIT_ERROR,
    payload: error,
  }
}
export const getAdminRecentVisit = () => {
  return {
    type: GET_ADMIN_RECENT_VISIT,
  }
}

export const getAdminRecentVisitSuccess = payload => {
  return {
    type: GET_ADMIN_RECENT_VISIT_SUCCESS,
    payload: payload
  }
}

export const getAdminRecentVisitError = error => {
  return {
    type: GET_ADMIN_RECENT_VISIT_ERROR,
    payload: error,
  }
}

export const postAdminClientInviteMail = payload => ({
  type: SEND_ADMIN_CLIENT_INVITE_MAIL,
  payload: payload
})

export const postAdminClientInviteMailSucess = payload => ({
  type: SEND_ADMIN_CLIENT_INVITE_MAIL_SUCCESS,
  payload: payload
})

export const postAdminClientInviteMailError = error => ({
  type: SEND_ADMIN_CLIENT_INVITE_MAIL_ERROR,
  payload: error
})